"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicRequest = void 0;

var _headers = require("../../state/headers");

var _getRequestWithBoundHeaders = _interopRequireDefault(require("./getRequestWithBoundHeaders"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getPublicRequest = function getPublicRequest(client) {
  var headers = (0, _headers.toHeadersRecord)((0, _headers.selectAllHeaders)(client.getState()));
  return Promise.resolve((0, _getRequestWithBoundHeaders["default"])(headers));
};

exports.getPublicRequest = getPublicRequest;